import "./styles.less";

import { Badge } from "antd";
import { BellOutlined } from "shared-components/Components/CustomIcons/BellOutlinedIcon/web";
import { UserOutlined } from "shared-components/Components/CustomIcons/UserOutlinedIcon/web";
import React, { useMemo, useState } from "react";
import { Button } from "shared-components/Components/Buttons/web";
import { Logout } from "../../../Components/User/LogOut/web";
import { openAuthModal } from "../../../Components/User/AuthModal/openAuthModal";
import { useUserBox } from "./hook";
import { privateSeesPublishDropdown, publishOpensInNewTab } from "./ovRouting";

import dynamic from "next/dynamic"
import { ButtonGarantíasAlquiler } from "shared-components/Components/ButtonGarantíasAlquiler/web";
import { LoginIcon } from "shared-components/Components/CustomIcons/LoginIcon/web";
import { Arrow } from "src/Components/ViewFragments/AboutUs/OptionsLabel";
const NotificationList = dynamic(
	(): any => import("../../../Components/User/NotificationList/web").then(mod => mod.NotificationList),
	{ ssr: false }
)

const ArrowOption: React.FC<{ open: boolean }> = ({ open }) => {
	return (
		<Arrow style={{ transform: `rotate(${open ? '90deg' : '0deg'})`, transition: 'all 0.2s' }} />
	);
};

export const UserBox = ({ isMobile = false }) => {
	const { main_domain, data, country_code, user, isLoggedIn, dataPP, ov_path, toOV } = useUserBox();
	let urlPublicateProperty = "https://" + main_domain + "/sitio/index.php?mid=propiedades&func=add";
	const [openMenu, setOpenMenu] = useState<boolean>(false);
	const [openPublicateProperty, setOpenPublicateProperty] = useState<boolean>(false);
	const [openNotification, setOpenNotification] = useState<boolean>(false);

	if (country_code === "ce3") urlPublicateProperty = "https://www.infocasas.com.uy/publicar-alquiler-temporario"
	if (toOV) {
		urlPublicateProperty = `${ov_path}publicar`;
	}

	const handleClickLogin = (e) => {
		e.preventDefault();

		openAuthModal({ defaultModalType: "LogIn", isFromCta: true })
	}

	const IrisButton = (
		<a className={isMobile ? 'header_btn_mobile' : 'header_btn'} href={"https://" + main_domain + "/proyectos/iris"}>
			{"Iris"}
		</a>
	);

	const publishTextLinkClass = `${isMobile ? "header_btn_mobile" : "btn-publish-text-link"}`;

	const PublicatePropertyButton = useMemo(() => {
		const useCoTextLink = country_code === "CO";

		if (!isLoggedIn) {
			return (
				<div
					className={`${useCoTextLink ? publishTextLinkClass : `${isMobile ? "header_btn_mobile" : "btn-header-text"} ${country_code}`}`}
					style={useCoTextLink ? undefined : { color: 'white !important' }}
					onClick={() => {
						openAuthModal({ withPromise: true }).then(() => {
							window?.open(urlPublicateProperty, '_blank')
						})
					}}
				>
					{"Publica tu propiedad"}
				</div>
			)
		}

		return (
			<a
				className={`${useCoTextLink ? publishTextLinkClass : `btn-publish ${isMobile ? "header_btn_mobile" : ""} ${country_code}`}`}
				href={urlPublicateProperty}
				style={useCoTextLink ? undefined : { color: 'white !important' }}
				target={publishOpensInNewTab(user?.data?.me, country_code) ? "_blank" : "_self"}>
				{"Publica tu propiedad"}
			</a>
		);
	}, [isLoggedIn, isMobile, country_code, urlPublicateProperty, publishTextLinkClass]);

	const LoginUserButton =
		isMobile ?
			<span className="header_btn_mobile btn-secondary" onClick={handleClickLogin}>
				<LoginIcon width={16} /> {"Ingresar"}
			</span>
			:
			<Button type="noStyle" onClick={handleClickLogin} className="btn-primary">
				<LoginIcon width={16} /> {"Ingresar"}
			</Button>
		;

	const PublicatePropertyDropdown = <MenuDropDown
		isMobile={isMobile}
		btnClass={`${!isMobile ? "btn-header-text" : ""} ${isLoggedIn ? "btn-header-highlight" : ""}`}
		open={openPublicateProperty}
		setOpen={setOpenPublicateProperty}
		text={
			isMobile ? (<>
				<div className="user-data-menu">
					<span className="username">Publica tu Propiedad</span>
				</div>
				<ArrowOption open={openPublicateProperty} />
			</>) :
				(
					"Publica tu Propiedad"
				)
		}
		content={dataPP.map((e, i) => (
			<a key={"key_favorite" + i}
				className={isMobile ? 'header_btn_mobile' : ''}
				target={e.target ?? "_self"}
				href={e.url.substring(0, 4) === "http" ? e.url : "https://" + main_domain + e.url}>
				{e.title}
			</a>
		))}
	/>

	return (
		<div className={isMobile ? 'userbox-mobile' : 'userbox'}>
			{/* Garantías de Alquiler */}
			{(country_code === "UY" && isLoggedIn && !user?.data?.me?.individual) &&
				<ButtonGarantíasAlquiler isMobile={isMobile} />
			}

			{/* Ir a Iris */}
			{user?.data?.me?.isIris && (country_code != "BR" && country_code != "ce3") && IrisButton}

			{/* Contacto */}
			{country_code === "ce3" &&
				<a className={isMobile ? 'header_btn_mobile' : 'header_btn'} href="/contacto">
					{"Contacto"}
				</a>
			}

			{/* Publicar Propiedad */}
			{isLoggedIn
				? privateSeesPublishDropdown(user?.data?.me, country_code)
					? PublicatePropertyDropdown
					: PublicatePropertyButton
				: country_code === "ce3" || country_code === "CO"
					? PublicatePropertyButton
					: PublicatePropertyDropdown
			}

			{/* Login  */}
			{isLoggedIn ? <>
				<MenuDropDown
					isMobile={isMobile}
					open={openMenu}
					setOpen={setOpenMenu}
					btnClass={`${!isMobile ? 'btn-user btn-header-text' : 'btn-user-mobile'}`}
					text={
						isMobile ? (<>
							<div className="user-data-menu">
								<span className="icon-user"><UserOutlined width={16} /></span>
								<span className="username">{user?.data?.me.name}</span>
							</div>
							<ArrowOption open={openMenu} />
						</>) :
							(
								<>
									<span className="icon-user"><UserOutlined width={16} /></span>
									<span className="username">{user?.data?.me.name}</span>
								</>
							)
					}
					content={<>
						{data.map((e, i) => (
							<a className={isMobile ? 'header_btn_mobile' : ''} key={"key_user_data " + i} target={e.target ?? "_self"} href={e.url.substring(0, 4) === "http" ? e.url : "https://" + main_domain + e.url}>{e.title}</a>
						))}
						<Logout className={`${isMobile ? 'header_btn_mobile' : ''} ${(country_code == 'UY' && isMobile) ? 'header_btn_mobile--logout' : ''}`} />
					</>}
				/>
			</> :
				LoginUserButton
			}

			{/* Notificaciones  */}
			{isLoggedIn && <>
				<MenuDropDown
					isMobile={isMobile}
					contentClass="noHover dropdown-to-left"
					open={openNotification}
					setOpen={setOpenNotification}
					btnClass={`${isMobile ? "btn-secondary" : "btn-notification btn-header-text"}`}
					text={isMobile ? (
						<>
							<div className="notification-box">
								<Badge
									count={user?.data?.me.unread_notifications}
									overflowCount={9}
									size={"small"}
								>
									<BellOutlined width={20} />
								</Badge>
								<span>Notificaciones</span>
							</div>
							<ArrowOption open={openNotification} />
						</>
					) :
						(
							<Badge
								count={user?.data?.me.unread_notifications}
								overflowCount={9}
								size={"small"}
							>
								<BellOutlined width={20} />
							</Badge>
						)}
					content={<>
						<NotificationList />
					</>}
				/>
			</>}
		</div>
	);
};

const MenuDropDown = (
	{ text, content, isMobile = false, contentClass = '', btnClass = '', open = false, setOpen = () => { } }
		: { text: any, content: any, isMobile?: boolean, contentClass?: string, btnClass?: string, open: boolean, setOpen: (open) => void }
) => {
	return (!isMobile ? <>
		<div className="userbox-dropdown">
			<div className={btnClass}>
				{text}
			</div>
			<div className={`userbox-dropdown-content ${contentClass}`}>
				{content}
			</div>
		</div>
	</> : <>
		<div className={`${btnClass} header_btn_mobile`} onClick={() => { setOpen(!open) }}>
			{text}
		</div>
		{open &&
			<div className={`userbox-dropdown-content_mobile ${contentClass}`}>
				{content}
			</div>
		}
	</>)
}